<template>
  <div>
    <b-modal
      id="modalImportXml"
      size="xl"
      title=""
      dialog-class="xml-import-dialog"
    >
      <template #modal-title>
        <div class="headerModal">
          <span class="titleModal">Importação de XML</span>
        </div>
      </template>
      <div>
        <b-row class="inputXml">
          <b-form-file
            style="width: 70%"
            placeholder="Selecione um XML ou arraste e solte aqui..."
            drop-placeholder="Solte o arquivo aqui..."
            size="sm"
            id="fileXml"
            v-model="xmlFile"
            browse-text="Arquivo"
          ></b-form-file>
          <b-button
            class="linkXml"
            :disabled="this.isLoading"
            @click="converXmlAndReturnObjectAndSave"
            >Ler Xml <b-spinner class="spin" v-if="this.isLoading" />
          </b-button>
        </b-row>
        <div class="tableProducts">
          <span class="titleProducts">Produtos contidos no XML</span>
          <div class="headProducts">
            <p style="width: 30%">Nome</p>
            <p style="width: 8%">Quant</p>
            <p style="width: 8%">Vl. Unitário</p>
            <p style="width: 8%">Vl. Total</p>
            <p style="width: 24%; margin-right: 2%">Produto Existente</p>
            <p style="width: 10%">CFOP</p>
            <p style="width: 10%">Vincular</p>
          </div>
          <div
            class="rowProducts"
            v-for="(item, index) in productsListGrid"
            :key="item.uuid"
          >
            <div
              style="
                width: 30%;
                display: flex;
                align-items: center;
                gap: 0.2rem;
              "
            >
              <b-icon-check-square-fill
                v-if="item.exists"
                style="color: green"
                scale="1.5"
                v-b-tooltip.hover.top="'Cadastrado'"
              />

              <b-icon-x-square-fill
                v-else
                style="color: brown"
                scale="1.5"
                v-b-tooltip.hover.top="'Não Cadastrado'"
              />

              <p>{{ item.nome }}</p>
            </div>
            <div class="quantityColumn" style="width: 8%">
              <b-form-input
                :value="item.quantidade"
                type="number"
                min="0.00001"
                step="any"
                class="quantityInput"
                :disabled="isLoading"
                :state="isValidQuantity(item.quantidade) ? null : false"
                :aria-label="`Quantidade de entrada para ${item.nome}`"
                @input="handleQuantityChange($event, index)"
              />
              <small class="xmlQuantity">
                XML: {{ originalProductQuantities[index] }}
              </small>
            </div>
            <p style="width: 8%">
              {{
                item.valor.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </p>
            <p style="width: 8%">
              {{
                (item.valor * item.quantidade).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </p>
            <div class="selectPlus" style="width: 24%; margin-right: 2%">
              <!-- <b-form-select
                class="borderInput shadow-none"
                text-field="nome"
                value-field="id"
                v-model="idProductForSelectBox[index]"
                size="sm"
                :options="productsForSelectBox"
              ></b-form-select> -->

              <InputInfinit
                :key="`prod-${index}-${productRefreshVersions[index] || 0}`"
                style="width: 100%"
                typeFilter="itens"
                :enableIconCreate="true"
                label=""
                :dataInput.sync="idProductForSelectBox[index]"
                :onSearch="fillProductsComboBoxWithPaginate"
                :searchFields="['nome', 'codRef']"
                :openCreateModal="
                  () =>
                    openModalCreateProduct(
                      idProductForSelectBox[index],
                      index
                    )
                "
              />
            </div>
            <div class="selectPlus" style="width: 10%">
              <b-form-select
                class="borderInput shadow-none"
                text-field="text"
                value-field="value"
                v-model="objectPurchaseTotal.products[index].cfop"
                size="sm"
                :options="cfopOptions"
              >
                <template #first>
                  <b-form-select-option :value="''" disabled>
                    -- Selecione o CFOP --
                  </b-form-select-option>
                </template>
              </b-form-select>
            </div>
            <b-button
              :disabled="
                !idProductForSelectBox[index] ||
                isProductLinked(item) ||
                !isValidQuantity(item.quantidade)
              "
              style="width: 10%"
              class="linkProduct"
              @click="assingProducts(index, idProductForSelectBox[index])"
              >Vincular</b-button
            >
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="content-btn">
          <b-button @click="cancel" class="CancelBtn">Cancelar</b-button>
          <div class="saveBtn" style="gap: 10px" v-if="isLoading">
            <b-spinner class="spin" style="color: green" />
            <span>Aguarde ...</span>
          </div>
          <b-button v-else @click="saveAllPurchase" class="saveBtn"
            >Salvar produtos
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- <b-modal id="modal-center3" hide-footer hide-header centered title="assign">
      <div class="contentNot">
        <div class="contentNot">
          <img class="alertImg" :src="alert" />
          <span>Já existe uma nota importada com essa chave</span>
          <span>Deseja prosseguir ?</span>
        </div>
        <div class="btnModal">
          <button class="btnContent" @click="assignValuesToTheObjectPurchase">
            Continuar
          </button>
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-center3')"
          >
            Não, Obrigado!
          </button>
        </div>
      </div>
    </b-modal> -->

    <b-modal id="modal-bill" hide-footer hide-header centered title="bill">
      <div class="contentNot">
        <div class="contentNot">
          <img class="alertImg" :src="alert" />
          <span>Deseja Realizar o lançamento dessa conta ?</span>
        </div>
        <div class="btnModal">
          <button class="btnContent" @click="generateDuplicate">
            Ir para o Financeiro
          </button>
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-bill')"
          >
            Não, Obrigado!
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { v4 as uuidv4 } from "uuid";

import InputInfinit from "../../components/UI/CustomInputs/InputInfinit.vue";

import api from "../../services/axios";
import ConvertXml from "../../services/serviceConvertXml";
import AssigningValuesToTheObject from "../../services/assigningValues​ToTheObject";
import ServiceImportMovimentPurchase from "../../services/serviceImportMovimentPurchase";
import ServiceProducts from "../../services/serviceProducts";
import ServiceDfe from "../../services/serviceDfe";

import alert from "../../assets/alert.svg";
import toastAlertErros from "../../utils/toastAlertErros";
import { HandleErrors } from "../../utils/handleErrors";
import { removeReference } from "../../utils/removeReference";
import { cfop } from "../../common/index";

export default {
  props: {
    cfopSelect: {
      type: String,
    },
    payloadFromDfe: {
      type: Object,
    },
    productUpdated: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    InputInfinit,
  },
  data() {
    return {
      alert: alert,
      xmlFile: null,
      objectPurchaseTotal: {},
      productsListGrid: [],
      productsForSelectBox: [],
      idProductForSelectBox: [],
      cfopOptions: cfop,
      objectGenerateDuplicate: {},
      isLoading: false,
      productIndexFromSearch: null,
      productRefreshVersions: [],
      originalProductQuantities: [],
      originalProductTotals: [],
    };
  },

  methods: {
    ...mapMutations(["SET_DATA_SEARCH_FROM_BILL"]),
    openModalCreateProduct(idProduct, index) {
      this.productIndexFromSearch = index;
      this.$emit("openProductModal", idProduct);
    },
    refreshUpdatedProduct() {
      if (this.productIndexFromSearch === null) return;

      const currentVersion =
        this.productRefreshVersions[this.productIndexFromSearch] || 0;

      this.$set(
        this.productRefreshVersions,
        this.productIndexFromSearch,
        currentVersion + 1
      );
    },

    async convertXml() {
      try {
        if (this.xmlFile === null && !this.payloadFromDfe.xml) {
          this.$toast.open({
            message: "Selecione o arquivo XML!",
            type: "warning",
          });
          return null;
        }
        const FIVE_MB = 5 * 1024 * 1024;
        if (this.xmlFile && this.xmlFile.size > FIVE_MB) {
          this.$toast.open({
            message: "O arquivo XML excede o tamanho máximo permitido (5 MB).",
            type: "warning",
          });
          return null;
        }

        let xmlConvertedToString;
        if (this.payloadFromDfe.xml) {
          xmlConvertedToString = this.payloadFromDfe.xml;
        } else {
          xmlConvertedToString = await ConvertXml.xmlString(this.xmlFile);
        }

        if (xmlConvertedToString === null) {
          this.$toast.open({
            message: "O arquivo deve ser um XML VALIDO",
            type: "error",
          });
          return null;
        } else {
          const { data } = await api.post(
            "/purchasenote",
            { xmlString: xmlConvertedToString },
            {
              maxContentLength: FIVE_MB,
              maxBodyLength: FIVE_MB,
            }
          );
          return data;
        }
      } catch (error) {
        const typeError = HandleErrors(error?.response?.data?.message);

        return this.$toast.open({
          message:
            typeError?.message || "ocorreu um erro ao converter o arquivo XML",
          type: "info",
        });
      }
    },
    async converXmlAndReturnObjectAndSave() {
      try {
        this.isLoading = true;
        const xmlConverted = await this.convertXml();
        const data = ConvertXml.ObjectPurchase(xmlConverted);
        this.objectPurchaseTotal =
          AssigningValuesToTheObject.assigningValues(data);
        const prodGrid = removeReference(this.objectPurchaseTotal.products);

        this.originalProductQuantities = prodGrid.map((prod) => prod.quantidade);
        this.originalProductTotals = prodGrid.map(
          (prod) => prod.valor * prod.quantidade
        );

        if (prodGrid.length) {
          for await (const prod of prodGrid) {
            const existsProd = await ServiceProducts.findByName(prod.nome);

            if (existsProd && existsProd.id) {
              prod.exists = true;
            } else {
              prod.exists = false;
            }
            prod.linked = false;
          }
        }

        this.productsListGrid = prodGrid;
      } catch (error) {
        return this.$toast.open({
          message: "Ocorreu um erro ao listar os produtos!",
          type: "error",
        });
      } finally {
        this.isLoading = false;
      }
    },

    async saveAllPurchase() {
      try {
        this.isLoading = true;
        if (!this.objectPurchaseTotal.purchase) return;

        if (
          this.productsListGrid.some(
            (product) => !this.isValidQuantity(product.quantidade)
          )
        ) {
          return this.$toast.open({
            message:
              "Informe uma quantidade de entrada maior que zero para todos os produtos.",
            type: "warning",
          });
        }

        const dataAllPurchase = {
          products: this.objectPurchaseTotal.products,
          supplier: this.objectPurchaseTotal?.supplier,
          purchase: this.objectPurchaseTotal?.purchase,
          key: this.objectPurchaseTotal?.key,
          valorNfe: this.objectPurchaseTotal.purchase.valorNfe,
          valorFrete: this.objectPurchaseTotal.purchase.valorFrete,
        };

        dataAllPurchase.purchase.cfop = this.cfopSelect;
        const { data } = await ServiceImportMovimentPurchase.save(
          dataAllPurchase
        );

        if (this.payloadFromDfe.fromDfe) {
          try {
            const mainfestPayload = {
              chNFe: dataAllPurchase.purchase.chaveNfe,
              tipoEvento: 210200,
            };

            await ServiceDfe.updateSetSynced(dataAllPurchase.purchase.chaveNfe);
            await ServiceDfe.manifestDfe([mainfestPayload]);
            // eslint-disable-next-line no-empty
          } catch (error) {}
        }

        this.addDataBill(data, dataAllPurchase);

        this.$emit("dataProduct", dataAllPurchase.products);
        this.$emit("idSupplierForSelectBox", data.idProvider);
        this.$emit("modalIdForPurchase", data.idPurchase);
        this.$emit("idMovimentPurchase", data.id);
        this.$emit(
          "valorNfe",
          dataAllPurchase.valorNfe.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          })
        );

        this.productsListGrid = [];

        this.$bvModal.show("modal-bill");
        this.$bvModal.hide("modalImportXml");

        return this.$toast.open({
          message: "Importado com sucesso!",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        const typeError = HandleErrors(message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        } else
          toastAlertErros.validateErroDoesNotContainFor(error, this.$toast);
      } finally {
        this.isLoading = false;
      }
    },

    async getProductsForSelectBox() {
      try {
        const products = await ServiceProducts.getProductsForSelectBox();
        this.productsForSelectBox = products.data.map((item) => {
          return {
            ...item,
            uuid: uuidv4(),
          };
        });
      } catch (error) {
        return this.$toast.open({
          message: "Ocorreu um erro ao listar os produtos!",
          type: "error",
        });
      }
    },

    isProductLinked(product) {
      return product.linked === true;
    },

    isValidQuantity(quantity) {
      return (
        quantity !== "" &&
        quantity !== null &&
        Number.isFinite(Number(quantity)) &&
        Number(quantity) > 0
      );
    },

    handleQuantityChange(quantity, index) {
      this.$set(this.productsListGrid[index], "quantidade", quantity);

      if (!this.isValidQuantity(quantity)) return;

      const quantityNumber = Number(quantity);
      const unitValue = Number(
        (this.originalProductTotals[index] / quantityNumber).toFixed(5)
      );

      this.$set(this.productsListGrid[index], "quantidade", quantityNumber);
      this.$set(this.productsListGrid[index], "estoque", quantityNumber);
      this.$set(this.productsListGrid[index], "valor", unitValue);
      this.$set(
        this.objectPurchaseTotal.products[index],
        "quantidade",
        quantityNumber
      );
      this.$set(
        this.objectPurchaseTotal.products[index],
        "estoque",
        quantityNumber
      );
      this.$set(this.objectPurchaseTotal.products[index], "valor", unitValue);
    },

    async fillProductsComboBoxWithPaginate(id, q, filterType, page) {
      try {
        return await ServiceProducts.fillComboBoxWithPaginate(
          id,
          q,
          filterType,
          page
        );
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os produtos",
          type: "info",
        });
      }
    },

    async assingProducts(index, idProduct) {
      try {
        if (!this.isValidQuantity(this.productsListGrid[index].quantidade)) {
          return;
        }

        const productToLink = await ServiceProducts.getProductById(idProduct);

        if (!productToLink) {
          this.$toast.open({
            message: "Produto selecionado para vínculo não foi encontrado.",
            type: "error",
          });
          return;
        }

        if (!this.isValidQuantity(this.productsListGrid[index].quantidade)) {
          return;
        }

        const currentProduct = this.productsListGrid[index];

        const linkedProduct = {
          ...currentProduct,
          id: productToLink.id,
          nome: productToLink.nome,
          codigo: productToLink.codigo,
          quantidade: currentProduct.quantidade,
          valor: currentProduct.valor,
          cfop: this.objectPurchaseTotal.products[index].cfop,
          exists: true,
          linked: true,
        };

        this.$set(this.objectPurchaseTotal.products, index, linkedProduct);
        this.$set(this.productsListGrid, index, linkedProduct);

        this.$toast.open({
          message: "Vínculo realizado com sucesso!",
          type: "success",
        });
      } catch (error) {
        console.error("Erro ao vincular o produto:", error);
        this.$toast.open({
          message: "Ocorreu um erro ao tentar vincular o produto.",
          type: "error",
        });
      }
    },
    addDataBill(data, dataAllPurchase) {
      this.objectGenerateDuplicate.valorTotal =
        dataAllPurchase.purchase.valorNfe;

      this.objectGenerateDuplicate.idFornecedor = data.idProvider;
      this.objectGenerateDuplicate.descricao = `Referente a nota de compra N°${dataAllPurchase.purchase.numeroNfe}`;
    },

    async generateDuplicate() {
      this.$toast.open({
        message: "Elaborado uma duplicata a partir de uma nota de compra!",
        type: "success",
      });

      this.SET_DATA_SEARCH_FROM_BILL(this.objectGenerateDuplicate);

      return this.$router.push({
        path: `/financeiro`,
      });
    },
  },

  mounted() {
    this.getProductsForSelectBox();
    if (this.payloadFromDfe.xml) {
      this.$bvModal.show("modalImportXml");
      this.converXmlAndReturnObjectAndSave();
    }
  },
  computed: {
    productsLinkedIds() {
      return (
        this.objectPurchaseTotal.products?.map((p) => p.id).filter(Boolean) ||
        []
      );
    },
  },
  watch: {
    productUpdated() {
      this.refreshUpdatedProduct();
    },
  },
};
</script>

<style scoped>
.inputXml {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  font-size: 13px;
  text-align: center;
  background: #fffcfc;
}

.headerModal {
  font-size: 16px !important;
  font-weight: bold;
}

.spin {
  right: 5px;
  height: 20px;
  width: 20px;
  color: white;
}

.alertModal {
  font-size: 11px;
  color: rgb(115, 0, 0);
  padding-left: 40px;
}

.tableProducts {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  padding: 30px 10px 10px 10px;
  width: 100%;
  font-size: 13px;
  height: 60vh;
  max-height: 60vh;
  overflow: scroll;
  text-align: center;
  background: #fffcfc;
}

.titleProducts {
  font-size: 16px;
  text-align: center;
  margin-bottom: 30px;
  cursor: context-menu;
}

.custom-file-label::after {
  background: red !important;
}

.headProducts {
  display: flex;
  border-bottom: 2px solid #d5d3d3;
  font-size: 12px;
  font-weight: bold;
}

.headProducts p {
  margin-bottom: 0rem !important;
}

.rowProducts p {
  margin-bottom: 0rem !important;
}

.rowProducts {
  display: flex;
  gap: 5px;
  min-height: 55px;
  border-bottom: 1px solid #f1efef;
  width: 100%;
  align-items: center;
}

.quantityColumn {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.quantityInput {
  width: 100%;
  height: 28px;
  padding: 2px 4px;
  font-size: 12px;
  text-align: center;
}

.xmlQuantity {
  font-size: 10px;
  color: #666;
  white-space: nowrap;
}

.linkProduct {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: #00486e;
  color: white;
  border-radius: 3px;
  border: none;
  width: 100px;
  height: 28px;
  gap: 10px;
  box-shadow: 0px 1px 1px 0px black;
}

.linkProduct:hover {
  background: #002a40;
  color: whitesmoke;
}

.linkXml {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: #00486e;
  border: none;
  color: white;
  border-radius: 3px;
  width: 100px;
  height: 28px;
  gap: 10px;
  box-shadow: 0px 1px 1px 0px black;
}

.linkXml:hover {
  background: #002a40;
  color: whitesmoke;
}

.saveBtn {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: rgb(255, 255, 255);
  border: 1px solid green;
  color: green;
  border-radius: 3px;
  width: 180px;
  height: 28px;
  box-shadow: 0px 1px 1px 0px black;
}

.saveBtn:hover {
  background: whitesmoke;
  border: 1px solid green;
  color: green;
}

.CancelBtn {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: rgb(255, 255, 255);
  border: 1px solid red;
  color: red;
  border-radius: 3px;
  width: 180px;
  height: 28px;
  box-shadow: 0px 1px 1px 0px black;
}

.CancelBtn:hover {
  background: whitesmoke;
  border: 1px solid red;
  color: red;
}

.selectPlus {
  position: relative;
  width: 30%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect {
  position: absolute;
  font-size: 12px;
  bottom: 12px;
  left: 10px;
  background-color: #ffffff;
  padding: 0 0.4em;
}

.borderInput {
  font-size: 12px;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.contentNot {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.alertImg {
  width: 100px;
  height: 100px;
}

.btnModal {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #00486e;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #00486e;
}

.btnContentReceive {
  font-size: 11px;
  border: 1px solid #00486e;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #00486e;
  background: white;
}

.content-btn {
  display: flex;
  align-items: center;
  justify-content: space-around !important;
  width: 100%;
}

.custom-select {
  padding: 0.375rem 0.25rem 0.375rem 0.75rem;
  line-height: 1.5;
  background: none;
}

@media screen and (max-width: 700px) {
  .tableProducts {
    padding: 0px;
    font-size: 11px;
  }

  .headProducts {
    font-size: 11px;
  }

  .rowProducts div {
    width: auto !important;
    min-width: 120px;
  }

  .rowProducts p {
    width: auto !important;
    min-width: 80px;
  }
}
</style>

<style>
/* O diálogo é renderizado fora deste componente pelo Bootstrap-Vue. */
.modal-dialog.xml-import-dialog {
  margin-top: calc(50px + 1rem);
}

.xml-import-dialog .modal-content {
  max-height: calc(100vh - 50px - 2rem);
}

.xml-import-dialog .modal-body {
  min-height: 0;
  overflow-y: auto;
}
</style>
